export default __webpack_public_path__ + "static/media/Banner1.ea5fecc2.png";